import {
  chainDynamicValue,
  DynamicValue,
  useComponentState,
} from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useRouter } from "next/router";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Card,
  Col,
  Form,
} from "react-bootstrap";
import FormJoinUsContact from "src/components/FormJoinUsContact";
import FormSelect from "src/components/FormSelect";
import Heading from "src/components/Heading";
import MqGteTablet from "src/components/MqGteTablet";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import gutter from "src/functions/gutter";
import onChangeToValue from "src/functions/onChangeToValue";
import optionsChannel from "src/functions/optionsChannel";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sNote } from "src/styles/sNote.module.scss";
import { DataJoinUsForm } from "src/types/DataJoinUsForm";

type Props = { formData: DynamicValue<DataJoinUsForm> };

function FormJoinUsCommunication({ formData }: Props) {
  var toggleAccordion = useComponentState(false);
  const { locale: lang } = useRouter();
  return (
    <Accordion
      defaultActiveKey={`1`}
      className={composeClassNames([sFormAccordion, "joinus-communication"])}
    >
      <Card>
        <AccordionToggle eventKey={`0`}>
          <Heading
            type={`h2`}
            title={
              <>
                {`4. `}
                <Translate tKey={`Communication`} />
                <Text size={`md`} width={`regular`}>
                  {`2 `}
                  <Translate tKey={`min.`} />
                </Text>
              </>
            }
          />
        </AccordionToggle>
        <AccordionCollapse eventKey={`0`}>
          <Card.Body>
            <Heading
              type={`h4`}
              title={<Translate tKey={`Preferred communication channels`} />}
            />
            <Form.Group>
              <Form.Text
                className={sNote}
                style={gutter(`margin`, `bottom`, `md`)}
              >
                <Translate
                  tKey={`Specify the communication channels through which you usually stream or hold online meetings. You can select one to three options.`}
                />
              </Form.Text>
              <Form.Row>
                <Col sm={4} xs={12}>
                  <FormSelect
                    as={`select`}
                    options={optionsChannel(lang)}
                    className={sFormControl}
                    id={`communication-channel-1`}
                    name={`communication-channel-1`}
                    onChange={function (param2) {
                      return chainDynamicValue(
                        formData,
                        "communication-channel-1"
                      ).change(onChangeToValue(param2));
                    }}
                    value={
                      chainDynamicValue(formData, "communication-channel-1")
                        .value
                    }
                  />
                </Col>
                <Col sm={4} xs={12}>
                  <FormSelect
                    as={`select`}
                    options={optionsChannel(lang)}
                    className={sFormControl}
                    id={`communication-channel-2`}
                    name={`communication-channel-2`}
                    onChange={function (param2) {
                      return chainDynamicValue(
                        formData,
                        "communication-channel-2"
                      ).change(onChangeToValue(param2));
                    }}
                    value={
                      chainDynamicValue(formData, "communication-channel-2")
                        .value
                    }
                  />
                </Col>
                <Col sm={4} xs={12}>
                  <FormSelect
                    as={`select`}
                    options={optionsChannel(lang)}
                    className={sFormControl}
                    id={`communication-channel-3`}
                    name={`communication-channel-3`}
                    onChange={function (param2) {
                      return chainDynamicValue(
                        formData,
                        "communication-channel-3"
                      ).change(onChangeToValue(param2));
                    }}
                    value={
                      chainDynamicValue(formData, "communication-channel-3")
                        .value
                    }
                  />
                </Col>
              </Form.Row>
            </Form.Group>
            <Heading
              type={`h4`}
              title={<Translate tKey={`Preferred contacts`} />}
            />
            <Form.Group>
              <Form.Text
                className={sNote}
                style={gutter(`margin`, `bottom`, `md`)}
              >
                <Translate
                  tKey={`Provide direct contacts that users can use to reach you.`}
                />
              </Form.Text>
              <MqGteTablet>
                <Form.Row>
                  <Col sm={4} xs={12}>
                    <Form.Label className={sFormLabel}>
                      <Translate tKey={`Contact type`} />
                    </Form.Label>
                  </Col>
                  <Col sm={4} xs={12}>
                    <Form.Label className={sFormLabel}>
                      <Translate tKey={`Contact information`} />
                    </Form.Label>
                  </Col>
                </Form.Row>
              </MqGteTablet>
              <FormJoinUsContact
                key={1}
                item={1}
                formDataContactType={chainDynamicValue(
                  formData,
                  "contact-type-1"
                )}
                formDataContactValue={chainDynamicValue(
                  formData,
                  "contact-value-1"
                )}
              />
              <FormJoinUsContact
                key={2}
                item={2}
                formDataContactType={chainDynamicValue(
                  formData,
                  "contact-type-2"
                )}
                formDataContactValue={chainDynamicValue(
                  formData,
                  "contact-value-2"
                )}
              />
              <FormJoinUsContact
                key={3}
                item={3}
                formDataContactType={chainDynamicValue(
                  formData,
                  "contact-type-3"
                )}
                formDataContactValue={chainDynamicValue(
                  formData,
                  "contact-value-3"
                )}
              />
            </Form.Group>
          </Card.Body>
        </AccordionCollapse>
      </Card>
    </Accordion>
  );
}

export default FormJoinUsCommunication;
